// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dTPt","productName":"Table_productName__3sV72"};